import type { ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { useRiderAppGate } from '@/hooks/useRiderAppEnabled'

// Route-level gate for the rider and dispatch pages (F-DLV-N1): nothing mounts
// — no polling, no stream — unless this tenant runs delivery riders.
export function RiderAppGate({ children }: { children: ReactNode }) {
  const gate = useRiderAppGate()
  if (gate.enabled) return <>{children}</>
  if (gate.isLoading) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>
  if (gate.isError)
    return (
      <div className="flex flex-col items-center gap-3 p-8 text-center">
        <p className="text-sm text-muted-foreground">Couldn’t load settings. Check your connection and try again.</p>
        <Button variant="outline" onClick={gate.retry}>
          Retry
        </Button>
      </div>
    )
  return (
    <div className="p-8 text-center text-sm text-muted-foreground">
      Delivery riders aren’t switched on for this restaurant.
    </div>
  )
}
